import { useEffect, useState } from "react";
import PlantationTechniquesAddPopup from "./PlantationTechniquesAddPopup/PlantationTechniquesAddPopup";
import { TrainingFrequencyDDL } from "../../../../CommonDDL/TrainingFrequencyDDL";
import { FrenceDDL } from "../../../../CommonDDL/FrenceDDL";
import { FrequencyForPesticidesDDL } from "../../../../CommonDDL/FrequencyForPesticidesDDL";
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../../Helper/Context/context";
import { PlantationDetailsPartThreeTableDataAPI } from "../../../../../Helper/Redux/AdminDashboardSlice/PlantationDetailsPartThirdSlice";
import { PesticidesPostAPI, PlantationDetailsPartFourPatchAPI, PlantationTechniquesDeleteAPI, ProtectFencingPostAPI, ThreatWildAnimalsPostAPI } from "../../../../../Helper/Redux/AdminDashboardSlice/PlantationDetailsPartFourthSlice";
import { Loading } from "../../../../../Helper/LogoLoader/LogoLoader";
import OtherInsertSection from "../OtherInsertSection";
import DeletePopUP from "../../../../CommonPopUp/DeletePopUp";
import AnimalsTable from "./AnimalsTable";
import FenceConstructedPlantationsTable from "./FenceConstructedPlantationsTable";
import PesticidesTable from "./PesticidesTable";
import { CommonCircle } from "../CommonCircle";
import { AstricSign } from "../../../../../Helper/AstricSign";

const PartFourPopup = (props) => {

    const { handleShowAddModal, handleIsPost, ShowAddModal, IsClear, setIsClear, YearValue, MonthValue, Title } = props
    const { flag, data } = ShowAddModal

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    const [RadioplantationTechniques, setRadioplantationTechniques] = useState('')
    const [ThreatFromCattle, setThreatFromCattle] = useState('')
    const [RadioWildAnimals, setRadioWildAnimals] = useState('')
    const [RadioProtectPlantations, setRadioProtectPlantations] = useState('')
    const [RadioPesticides, setRadioPesticides] = useState('')

    const [PlantationTechniquesPopup, setPlantationTechniquesPopup] = useState(false)
    const [PlantationDetailsPart4, setPlantationDetailsPart4] = useState([])
    const [PlantationTechniquesData, setPlantationTechniquesData] = useState([])
    const [AnimalsName, setAnimalsName] = useState('')
    const [CostOfFence, setCostOfFence] = useState('')
    const [PesticidesName, setPesticidesName] = useState('')
    const [DataIsPost, setDataIsPost] = useState(false)
    const [IsOthersData, setIsOthersData] = useState(false)
    const [IsAnimalData, setIsAnimalData] = useState(false)
    const [IsFenchData, setIsFenchData] = useState(false)
    const [IsPesticidesData, setIsPesticidesData] = useState(false)
    const [ShowDeletePopup, setShowDeletePopup] = useState(false)
    const [ShowDeletePopupData, setShowDeletePopupData] = useState({
        data: ''
    })

    const [TrainingFrequencyId, setTrainingFrequencyId] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [FenceId, setFenceId] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [FrequencyPesticidesId, setFrequencyPesticidesId] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleDataIsPost = () => {
        setDataIsPost(!DataIsPost)
        handleShowDelete()
    }

    const handleShowDelete = (data) => {
        setShowDeletePopup(!ShowDeletePopup)
        { data && setShowDeletePopupData(data) }
    }

    const handleAddplantationTechniques = () => {
        setPlantationTechniquesPopup(!PlantationTechniquesPopup)
    }

    useEffect(() => {
        const data = {
            FinancialYearID: YearValue,
            MonthID: MonthValue,
            T_BeneficiaryPlantationDetailsID: 0,
            M_BeneficiaryDetailsID: ShowAddModal.data.m_BeneficiaryDetailsID,
            M_TableUserMasterID: UserID,
            Flag: "PlantationPart4",
            token: token,
            setPlantationDetailsPart4: setPlantationDetailsPart4,
            PlantationTechniques: PlantationTechniques
        }
        if (YearValue && MonthValue) {
            dispatch(PlantationDetailsPartThreeTableDataAPI({ data }))

        }
    }, [IsAnimalData, IsFenchData, IsPesticidesData, YearValue, MonthValue])

    const PlantationTechniques = (value) => {

        const data = {
            FinancialYearID: YearValue,
            MonthID: MonthValue,
            T_BeneficiaryPlantationDetailsID: value && value[0]?.t_BeneficiaryPlantationDetailsID ? value && value[0]?.t_BeneficiaryPlantationDetailsID : 0,
            M_BeneficiaryDetailsID: ShowAddModal.data.m_BeneficiaryDetailsID,
            M_TableUserMasterID: UserID,
            Flag: "PlantationTechniques",
            token: token,
            setPlantationTechniquesData: setPlantationTechniquesData,
        }
        if (YearValue && MonthValue) {
            dispatch(PlantationDetailsPartThreeTableDataAPI({ data }))

        }
    }

    useEffect(() => {

        if (PlantationDetailsPart4 && PlantationDetailsPart4[0] && PlantationDetailsPart4[0]?.t_BeneficiaryPlantationDetailsID) {
            PlantationTechniques(PlantationDetailsPart4[0]?.t_BeneficiaryPlantationDetailsID)
        }
    }, [DataIsPost, YearValue, MonthValue])

    const { isLoading } = useSelector(state => state.PlantationDetailsPartThreeTableData)

    useEffect(() => {
        setRadioplantationTechniques(PlantationDetailsPart4 && PlantationDetailsPart4[0]?.plantationTechniques_M_IndicatorID)
        setThreatFromCattle(PlantationDetailsPart4 && PlantationDetailsPart4[0]?.threatCattle_M_IndicatorID)
        setRadioWildAnimals(PlantationDetailsPart4 && PlantationDetailsPart4[0]?.threatWildAnimals_M_IndicatorID)
        setAnimalsName(PlantationDetailsPart4 && PlantationDetailsPart4[0]?.threatWildAnimals_Name)
        setRadioProtectPlantations(PlantationDetailsPart4 && PlantationDetailsPart4[0]?.fence_Protect_Plantations_M_IndicatorID)
        setCostOfFence(PlantationDetailsPart4 && PlantationDetailsPart4[0]?.cost_Of_Fence)
        setRadioPesticides(PlantationDetailsPart4 && PlantationDetailsPart4[0]?.apply_Pesticides_M_IndicatorID)
        setPesticidesName(PlantationDetailsPart4 && PlantationDetailsPart4[0]?.whichPesticide)
    }, [PlantationDetailsPart4])

    const handleUpdate = () => {

        const data = {
            FinancialYearID: YearValue,
            MonthsID: MonthValue,
            // T_BeneficiaryPlantationDetailsID: ShowAddModal.data.t_BeneficiaryPlantationDetailsID,
            T_BeneficiaryPlantationDetailsID: 0,
            M_BeneficiaryDetailsID: ShowAddModal.data.m_BeneficiaryDetailsID,
            PlantationTechniques_M_IndicatorID: RadioplantationTechniques,
            Frequncy_M_IndicatorID: TrainingFrequencyId.ID,
            ThreatCattle_M_IndicatorID: ThreatFromCattle,
            ThreatWildAnimals_M_IndicatorID: RadioWildAnimals,
            Fence_Protect_Plantations_M_IndicatorID: RadioProtectPlantations,
            Apply_Pesticides_M_IndicatorID: RadioPesticides,
            M_TableUserMasterID: UserID,
            token: token,
            handleIsPost
        }
        dispatch(PlantationDetailsPartFourPatchAPI({ data }))
    }

    const { isPostLoading } = useSelector(state => state.PlantationDetailsPartFourPatchData)

    const handleDeleteData = () => {

        const data = {
            T_BeneficiaryPlantationDetails_PlantationTechniquesID: ShowDeletePopupData?.t_BeneficiaryPlantationDetails_PlantationTechniquesID,
            M_TableUserMasterID: UserID,
            token: token,
            handleDataIsPost
        }
        dispatch(PlantationTechniquesDeleteAPI({ data }))
    }

    const { isDeleteLoading } = useSelector(state => state.PlantationTechniquesDeleteData)


    // ------------------Threat from wild animals Post API--------------------------

    // const handleIsAnimalData = () => {
    //     // setIsAnimalData(!IsAnimalData)
    //     // setAnimalsName('')
    // }

    const handleThreatWildUpdateData = () => {
        const data = {
            T_BeneficiaryPlantationDetailsID: PlantationDetailsPart4 && PlantationDetailsPart4[0]?.t_BeneficiaryPlantationDetailsID ? PlantationDetailsPart4 && PlantationDetailsPart4[0]?.t_BeneficiaryPlantationDetailsID : 0,
            ThreatWildAnimals_Name: AnimalsName,
            M_TableUserMasterID: UserID,
            token: token,
            // handleIsAnimalData: handleIsAnimalData
        }
        dispatch(ThreatWildAnimalsPostAPI({ data }))
    }

    const { isPostLoading1 } = useSelector(state => state.ThreatWildAnimalsPostData)

    // ------------------Fence constructed to protect the plantations Post API--------------------------

    // const handleIsFenchData = () => {
    //     // setIsFenchData(!IsFenchData)
    //     // setCostOfFence('')
    //     // setFenceId({
    //     //     DDL: [],
    //     //     ID: 0,
    //     //     Label: "Select...",
    //     // })

    // }

    const handleUpdateData = () => {
        const data = {

            T_BeneficiaryPlantationDetailsID: PlantationDetailsPart4 && PlantationDetailsPart4[0]?.t_BeneficiaryPlantationDetailsID ? PlantationDetailsPart4 && PlantationDetailsPart4[0]?.t_BeneficiaryPlantationDetailsID : 0,
            Kind_Of_Fence_M_IndicatorID: FenceId.ID,
            Cost_Of_Fence: CostOfFence,
            M_TableUserMasterID: UserID,
            token: token,
            // handleIsFenchData: handleIsFenchData
        }
        dispatch(ProtectFencingPostAPI({ data }))
    }

    const { isPostLoading2 } = useSelector(state => state.ProtectFencingPostData)

    // ------------------pesticides Post API--------------------------


    const handlePesticidesUpdateData = () => {
        const data = {
            T_BeneficiaryPlantationDetailsID: PlantationDetailsPart4 && PlantationDetailsPart4[0]?.t_BeneficiaryPlantationDetailsID ? PlantationDetailsPart4 && PlantationDetailsPart4[0]?.t_BeneficiaryPlantationDetailsID : 0,
            WhichPesticide: PesticidesName,
            Frequency_For_Pesticide_M_IndicatorID: FrequencyPesticidesId.ID,
            M_TableUserMasterID: UserID,
            token: token,
            // handleIsFenchData: handleIsFenchData
        }
        dispatch(PesticidesPostAPI({ data }))
    }

    const { isPostLoading3 } = useSelector(state => state.PesticidesPostData)

    return (
        <>
            {isLoading ? <Loading /> :
                <div className="modal fade show d-flex align-items-center" style={{ display: "block", backgroundColor: "#00000055" }}>
                    <div className="modal-dialog modal-lg " style={{ minWidth: '40vw' }} role="document"  >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title fw-bold text-danger modal-title-fs" id="exampleModalLongTitle">{Title}</h5>
                                <button onClick={() => handleShowAddModal(false, '')} type="button" className="close" style={{ marginLeft: "auto" }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body" style={{ overflowY: 'scroll', height: '80vh' }}>
                                <div className="row">

                                    <div className="col-12 col-lg-11 mx-auto py-2 border-bottom">
                                        <CommonCircle />
                                        <span className="">
                                            Received training for plantation Techniques <AstricSign /> :
                                        </span>

                                        <span className="px-3">
                                            <input type="radio" onChange={() => setRadioplantationTechniques('53')} id='53' name={RadioplantationTechniques == 53} value="53" checked={RadioplantationTechniques == 53 && "checked"} />
                                            <label for="huey">Yes</label>

                                        </span>
                                        <span>
                                            <input type="radio" onChange={() => setRadioplantationTechniques('54')} id='54' name={RadioplantationTechniques == 54} value="54" checked={RadioplantationTechniques == 54 && "checked"} />
                                            <label for="dewey">No</label>
                                        </span>
                                        {
                                            RadioplantationTechniques == 53 &&
                                            <span className=" add_button mx-3 px-3 py-1"
                                                onClick={() => handleAddplantationTechniques()}

                                            >
                                                <i class="fa-solid fa-plus"></i>  Add
                                            </span>
                                        }

                                        {

                                            RadioplantationTechniques == "53" ?

                                                <div className="table-responsive p-0 tableFixHead" >
                                                    <table className="table table-bordered">
                                                        <thead>
                                                            <tr className=" text-white">
                                                                {/* <th className="text-center">Sr. No.</th> */}
                                                                <th className="text-center">Training for plantation Techniques</th>
                                                                <th className="text-center">Action</th>


                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {

                                                                PlantationTechniquesData && PlantationTechniquesData.length > 0 ?
                                                                    PlantationTechniquesData.map((i, j) => {
                                                                        return (

                                                                            i.isCheck == 1 &&
                                                                            <tr>
                                                                                {/* <td align="center">{j + 1}</td> */}
                                                                                <td>{i.techniques_M_Indicator ? i.techniques_M_Indicator : '-'}</td>

                                                                                <td align="center">

                                                                                    <i className="fa fa-trash mx-2 text-danger v_icon_style"
                                                                                        onClick={() => handleShowDelete(i)}
                                                                                        title="Do you want to delete this record?"></i>
                                                                                </td>

                                                                            </tr>



                                                                        )
                                                                    })
                                                                    :
                                                                    <span style={{ color: "red" }}>No data found</span>
                                                            }


                                                        </tbody>
                                                    </table>

                                                </div>
                                                :
                                                ''
                                        }

                                    </div>

                                    <div className="col-12 col-lg-11 mx-auto py-3 border-bottom">
                                        <TrainingFrequencyDDL
                                            TrainingFrequencyId={TrainingFrequencyId}
                                            setTrainingFrequencyId={setTrainingFrequencyId}
                                            apiFlag='FrequencyOfTraining'
                                            Flag={flag}
                                            data={PlantationDetailsPart4 && PlantationDetailsPart4[0]}
                                            IsPost=''
                                            AstricSignFlag="AstricSign"
                                        />
                                    </div>

                                    <div className="col-12 col-lg-11 pt-3 pb-2 mx-auto border-bottom">
                                        <CommonCircle />
                                        <span className="">
                                            Threat from cattle <AstricSign /> :
                                        </span>

                                        <span className="px-3">
                                            <input type="radio" onChange={() => setThreatFromCattle('53')} id='53' name={ThreatFromCattle == 53} value="53" checked={ThreatFromCattle == 53 && "checked"} />
                                            <label for="huey">Yes</label>

                                        </span>
                                        <span>
                                            <input type="radio" onChange={() => setThreatFromCattle('54')} id='54' name={ThreatFromCattle == 54} value="54" checked={ThreatFromCattle == 54 && "checked"} />
                                            <label for="dewey">No</label>
                                        </span>
                                    </div>

                                    <div className="col-12 col-lg-11 pt-3 mx-auto border-bottom">
                                        <CommonCircle />
                                        <span className="">
                                            Threat from wild animals <AstricSign />  :
                                        </span>

                                        <span className="px-3">
                                            <input type="radio" onChange={() => setRadioWildAnimals('53')} id='53' name={RadioWildAnimals == 53} value="53" checked={RadioWildAnimals == 53 && "checked"} />
                                            <label for="huey">Yes</label>

                                        </span>
                                        <span>
                                            <input type="radio" onChange={() => setRadioWildAnimals('54')} id='54' name={RadioWildAnimals == 54} value="54" checked={RadioWildAnimals == 54 && "checked"} />
                                            <label for="dewey">No</label>
                                        </span>

                                        {

                                            RadioWildAnimals == "53" ?
                                                <>
                                                    <div className=" col-12 col-lg-8 pb-3">
                                                        <div className="py-1">
                                                            What is name of Animal <AstricSign /> :
                                                        </div>
                                                        <div class="input-group mb-3 ">

                                                            <input type="text"
                                                                className="form-control"
                                                                name="AnimalsName"
                                                                placeholder="type here"
                                                                value={AnimalsName}
                                                                onChange={(e) => setAnimalsName(e.target.value)}
                                                            />
                                                            <span className="input-group-text cursor-pointer text-white" id="basic-addon2" style={{ background: "#dc3545" }}
                                                                onClick={handleThreatWildUpdateData} >
                                                                Update</span>
                                                        </div>
                                                    </div>

                                                    <AnimalsTable
                                                        PlantationDetailsPart4={PlantationDetailsPart4}
                                                        setPlantationDetailsPart4={setPlantationDetailsPart4}
                                                        T_BeneficiaryPlantationDetailsID={PlantationDetailsPart4 && PlantationDetailsPart4[0]?.t_BeneficiaryPlantationDetailsID ? PlantationDetailsPart4 && PlantationDetailsPart4[0]?.t_BeneficiaryPlantationDetailsID : 0}
                                                        M_BeneficiaryDetailsID={ShowAddModal.data.m_BeneficiaryDetailsID}
                                                        IsAnimalData={IsAnimalData}
                                                        setIsAnimalData={setIsAnimalData}
                                                        setAnimalsName={setAnimalsName} />
                                                </>
                                                :
                                                ''
                                        }
                                    </div>

                                    <div className="col-12 col-lg-11 pt-3 pb-2 mx-auto border-bottom">
                                        <CommonCircle />
                                        <span className="">
                                            Fence constructed to protect the plantations <AstricSign /> :
                                        </span>

                                        <span className="px-3">
                                            <input type="radio" onChange={() => setRadioProtectPlantations('53')} id='53' name={RadioProtectPlantations == 53} value="53" checked={RadioProtectPlantations == 53 && "checked"} />
                                            <label for="huey">Yes</label>

                                        </span>
                                        <span>
                                            <input type="radio" onChange={() => setRadioProtectPlantations('54')} id='54' name={RadioProtectPlantations == 54} value="54" checked={RadioProtectPlantations == 54 && "checked"} />
                                            <label for="dewey">No</label>
                                        </span>

                                        {

                                            RadioProtectPlantations == "53" ?
                                                <>
                                                    <div className="col-12 col-lg-8">

                                                        <FrenceDDL
                                                            FenceId={FenceId}
                                                            setFenceId={setFenceId}
                                                            apiFlag='Fence'
                                                            Flag={flag}
                                                            data={PlantationDetailsPart4 && PlantationDetailsPart4[0]}
                                                            IsPost=''
                                                            AstricSignFlag="AstricSign"

                                                        />
                                                    </div>

                                                    <div className=" col-12 col-lg-8 pb-3">

                                                        <div className="row">
                                                            <div className="col-8">
                                                                <div className="py-1">
                                                                    Cost of Fence <AstricSign /> :
                                                                </div>
                                                                <div class="input-group mb-3 ">

                                                                    <input
                                                                        type="text"
                                                                        className="form-control "
                                                                        name="CostOfFence"
                                                                        placeholder="type.."
                                                                        value={CostOfFence}
                                                                        onChange={(e) => setCostOfFence(e.target.value)}
                                                                    />

                                                                </div>
                                                            </div>

                                                            <div className="col-3 pt-4 mt-3">

                                                                <span className=" cursor-pointer text-white update_button" id="basic-addon2" style={{ background: "#dc3545" }}
                                                                    onClick={handleUpdateData}
                                                                >
                                                                    Update</span>
                                                            </div>



                                                        </div>

                                                    </div>

                                                    <FenceConstructedPlantationsTable
                                                        PlantationDetailsPart4={PlantationDetailsPart4}
                                                        setPlantationDetailsPart4={setPlantationDetailsPart4}
                                                        T_BeneficiaryPlantationDetailsID={PlantationDetailsPart4 && PlantationDetailsPart4[0]?.t_BeneficiaryPlantationDetailsID ? PlantationDetailsPart4 && PlantationDetailsPart4[0]?.t_BeneficiaryPlantationDetailsID : 0}
                                                        M_BeneficiaryDetailsID={ShowAddModal.data.m_BeneficiaryDetailsID}
                                                        IsFenchData={IsFenchData}
                                                        setIsFenchData={setIsFenchData}
                                                        FenceId={FenceId}
                                                        setFenceId={setFenceId}
                                                        setCostOfFence={setCostOfFence} />
                                                </>
                                                :
                                                ''
                                        }
                                    </div>

                                    <div className="col-12 col-lg-11 pt-3 pb-3 mx-auto border-bottom">
                                        <CommonCircle />
                                        <span className="">
                                            Do you apply any pesticides? <AstricSign />:
                                        </span>

                                        <span className="px-3">
                                            <input type="radio" onChange={() => setRadioPesticides('53')} id='53' name={RadioPesticides == 53} value="53" checked={RadioPesticides == 53 && "checked"} />
                                            <label for="huey">Yes</label>

                                        </span>
                                        <span>
                                            <input type="radio" onChange={() => setRadioPesticides('54')} id='54' name={RadioPesticides == 54} value="54" checked={RadioPesticides == 54 && "checked"} />
                                            <label for="dewey">No</label>
                                        </span>

                                        {

                                            RadioPesticides == "53" ?
                                                <>
                                                    <div className=" col-12 col-lg-5 pb-3">
                                                        <div className="py-1">
                                                            Name of Pesticides <AstricSign /> :
                                                        </div>
                                                        <div class="input-group mb-1 ">

                                                            <input
                                                                type="text"
                                                                className="form-control "
                                                                name="PesticidesName"
                                                                placeholder="type.."
                                                                value={PesticidesName}
                                                                onChange={(e) => setPesticidesName(e.target.value)}
                                                            />

                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-lg-8 pt-3">
                                                        <div className="row">
                                                            <div className="col-lg-8">
                                                                <FrequencyForPesticidesDDL
                                                                    FrequencyPesticidesId={FrequencyPesticidesId}
                                                                    setFrequencyPesticidesId={setFrequencyPesticidesId}
                                                                    apiFlag='Pesticide'
                                                                    Flag={flag}
                                                                    data={PlantationDetailsPart4 && PlantationDetailsPart4[0]}
                                                                    IsPost={IsOthersData}
                                                                    AstricSignFlag="AstricSign"
                                                                />
                                                            </div>

                                                            <div className="col-4 col-lg-3 mb-3 pt-lg-4  mt-lg-3">

                                                                <span className=" cursor-pointer text-white update_button" id="basic-addon2" style={{ background: "#dc3545" }}
                                                                    onClick={handlePesticidesUpdateData}
                                                                >
                                                                    Update</span>
                                                            </div>

                                                        </div>

                                                    </div>

                                                    {
                                                        FrequencyPesticidesId.ID == 4 &&
                                                        <OtherInsertSection
                                                            Flag='Pesticides'
                                                            IsOthersData={IsOthersData}
                                                            setIsOthersData={setIsOthersData}
                                                        />
                                                    }

                                                    <PesticidesTable
                                                        PlantationDetailsPart4={PlantationDetailsPart4}
                                                        setPlantationDetailsPart4={setPlantationDetailsPart4}
                                                        T_BeneficiaryPlantationDetailsID={PlantationDetailsPart4 && PlantationDetailsPart4[0]?.t_BeneficiaryPlantationDetailsID ? PlantationDetailsPart4 && PlantationDetailsPart4[0]?.t_BeneficiaryPlantationDetailsID : 0}
                                                        M_BeneficiaryDetailsID={ShowAddModal.data.m_BeneficiaryDetailsID}
                                                        IsPesticidesData={IsPesticidesData}
                                                        setIsPesticidesData={setIsPesticidesData}
                                                        setPesticidesName={setPesticidesName}
                                                        FrequencyPesticidesId={FrequencyPesticidesId}
                                                        setFrequencyPesticidesId={setFrequencyPesticidesId}

                                                    />
                                                </>
                                                :
                                                ''
                                        }
                                    </div>

                                    <div className="col-12 pt-5 ">
                                        <div className="form-group w-80 d-flex justify-content-center">
                                            <button
                                                type='button'
                                                onClick={() => handleUpdate()}
                                                disabled={RadioplantationTechniques == '' || TrainingFrequencyId.ID == 0 || ThreatFromCattle == '' || RadioWildAnimals == '' || PesticidesName == '' ||
                                                    RadioProtectPlantations == '' || CostOfFence == '' || RadioPesticides == '' || FenceId.ID == 0 || FrequencyPesticidesId.ID == 0 || AnimalsName == ''}
                                                className="btn bg-success text-white border-2 mx-2 px-4" data-ktwizard-type="action-next">
                                                Update
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => handleShowAddModal(false, '')}
                                                className="btn btn-danger border-2" data-ktwizard-type="action-next">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            }

            {
                PlantationTechniquesPopup &&
                <PlantationTechniquesAddPopup
                    handleAddplantationTechniques={handleAddplantationTechniques}
                    Title='Training of plantation techniques'
                    T_BeneficiaryPlantationDetailsID={PlantationDetailsPart4 && PlantationDetailsPart4[0]?.t_BeneficiaryPlantationDetailsID ? PlantationDetailsPart4 && PlantationDetailsPart4[0]?.t_BeneficiaryPlantationDetailsID : 0}
                    M_BeneficiaryDetailsID={ShowAddModal.data.m_BeneficiaryDetailsID}
                    DataIsPost={DataIsPost}
                    setDataIsPost={setDataIsPost}
                    YearValue={YearValue}
                    MonthValue={MonthValue}
                />
            }

            {
                ShowDeletePopup ?
                    <DeletePopUP
                        handleShowDelete={handleShowDelete}
                        ShowDeletePopupData={ShowDeletePopupData}
                        handleDeleteData={handleDeleteData}

                    /> : <></>
            }



        </>);
}

export default PartFourPopup;